/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Contains declarations for all types of service which are supported by the system
 */
export enum EnumServiceType {
    /**
     * Not defined
     */
    NotDefined = 0,
    /**
     * A service which describes a material.
     * Materials can be transported, sold or deposited in storage.
     */
    Material = 1,
    /**
     * This service describes a service action.
     * Service actions are actions that can be performed at a site, without the involvement of a material, but potentially requiring tools
     */
    Service = 2,
    /**
     * This service type does not relate to any action.
     * It is only used to include a text in an order.
     */
    Textservice = 3,
}
